import { render, staticRenderFns } from "./LiveTradeChart.vue?vue&type=template&id=3908ea4e"
import script from "./LiveTradeChart.vue?vue&type=script&lang=js"
export * from "./LiveTradeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports